import styled from "styled-components";
import { device } from "../../../styles/breakpoints";

export const BIContent = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  gap: 4px;
  width: 100%;
  margin-top: 4px;
`;
export const BoldText = styled.div`
  color: #6f7171;
  font-feature-settings: "clig" off, "liga" off;
  /* [VDS] DeskTab/🖥 Body LG Bold */
  font-family: "Verizon-NHG-eDS";
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 125% */
  letter-spacing: 0.5px;
`;

export const LightText = styled.div`
  color: #6f7171;
  font-feature-settings: "clig" off, "liga" off;
  /* [VDS] DeskTab/🖥 Body LG */
  font-family: "Verizon-NHG-eDS";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.5px;
`;

export const AreaFloorContainer = styled.div`
   {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 12px;
  }
`;

export const NewLoaderContainer = styled.div`
   {
    position: relative;
    width: 460px;
    height: 100px;
  }
`;

export const CameraCancelSubmitFrame = styled.div`
  gap: 8px;
  display: flex;
  justify-content: space-between;
  position: sticky;
  bottom: 0;
`;

export const StreamDescriptiveText = styled.p`
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Verizon NHG DS";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.5px;
`;

export const AutomaticColibrationText = styled.p`
  float: left;
  margin-top: 5px;
  display: flex;
`;

export const AutomaticColibrationYes = styled.div`
  border-top: 3px solid green;
`;

export const AutomaticColibrationNo = styled.div`
  border-top: 3px solid orange;
`;
export const ColibrationHeadingYes = styled.h4`
  color: green;
  margin-top: 5px;
`;

export const ColibrationHeadingNo = styled.h4`
  color: orange;
  margin-top: 5px;
`;

export const VisionStreamCalibrationSnapshotItem = styled.div`
  flex: 1 1 calc(50% - 20px);
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const VisionStreamCalibrationSnapshot = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const BackAndNextButtonsContainer = styled.div`
  display: flex;
  width: 808px;
  justify-content: space-between !important;
  align-items: center;
  height: auto;
  margin-top: 15px;
`;

export const CalibrationRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;

  @media ${device.tablet} {
    gap: 24px;
  }
`;

export const CalibrationSnapshotCol = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  min-width: 0;
`;

export const CalibrationRadioCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 14px;

  @media ${device.tablet} {
    justify-content: center;
    padding-top: 8px;
    gap: 16px;
  }
`;

export const CalibrationSearchCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;

  @media ${device.tablet} {
    margin-left: auto;
    justify-content: center;
    padding-top: 8px;
    gap: 12px;
  }
`;

export const SearchCheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StreamNameSyncRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-top: 8px;
`;

export const StreamItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }
`;
